export enum CaseType {
  RefCase = 'RefCase',
  Case = 'Case'
}
